import React, { useState, useCallback, useEffect } from 'react'
import Axios from 'axios'
import Form from 'react-bootstrap/Form'
import GoogleMap from '../maps/googleMapView'

const EstateUpdate = (props) => {

    /* Endpoint url */
    const endpoint = props.base_url + "endpoint/estate"

    /* States */
    const [data, useData] = useState(props.data)
    const [initialCustomFields, setInitialCustomFields] = useState([])
    const [initialServices, setInitialServices] = useState([])
    const [thumbNailsRemove, setThumbNailsRemove] = useState([])

    /* Handles */
    const HandleCommonFields = (e) => {
        let new_data = { ...data }
        let name = e.target.getAttribute('id')
        let value = e.target.value
        new_data[name] = value
        useData(new_data)
    }
    const HandleCustomFields = (e) => {
        let new_data = { ...data }
        let description = e.target.getAttribute('data-attr')
        let name = e.target.getAttribute('id')
        let value = e.target.value
        if (new_data.custom_fields.custom_fields[name]) {
            new_data.custom_fields.custom_fields[name].value = [value]
            new_data.custom_fields.custom_fields[name].description = [description]
            new_data.custom_fields.custom_fields[name].name = [name]
        }
        else {
            let new_value = {
                name: [name],
                description: [description],
                value: [value]
            }
            new_data.custom_fields.custom_fields[name] = new_value
        }

        useData(new_data)
    }
    const HandleServicesFields = (e) => {
        let new_data = { ...data }
        let description = e.target.getAttribute('data-attr')
        let name = e.target.getAttribute('id')
        let value = e.target.value
        if (new_data.custom_fields.services[name]) {
            new_data.custom_fields.services[name].value = [value]
            new_data.custom_fields.services[name].description = [description]
            new_data.custom_fields.services[name].name = [name]
        }
        else {
            let new_value = {
                name: [name],
                description: [description],
                value: [value]
            }
            new_data.custom_fields.services[name] = new_value
        }
        useData(new_data)
    }

    /* Images */
    const AddMainImage = (event) => {
        let new_data = { ...data }
        new_data.image = event.target.files[0].name
        useData(new_data)
        uploadImage(event.target.files[0])
        document.getElementById('selectedFile').value = ""
    }

    const AddAdditionalImage = (event) => {
        const imagesPack = Object.values(event.target.files)
        let new_data = { ...data }
        let old_values = data.thumbnails
        let new_values = [...old_values]
        imagesPack.map((item) => {
            new_values = [...new_values, item.name]
            uploadImage(item)
            return new_values
        })
        new_data.thumbnails = new_values
        useData(new_data)
        document.getElementById('selectedFile2').value = ""
    }

    const RemoveAdditionalImage = (item) => {
        let newThumbNails
        const exists = thumbNailsRemove.includes(item)
        if (exists) {
            newThumbNails = thumbNailsRemove.filter((value) => {
                return value !== item
            })
            setThumbNailsRemove(newThumbNails)

        }
        else {
            setThumbNailsRemove([...thumbNailsRemove, item])

        }
    }

    const RemoveSelected = () => {
        let currentData = { ...data }
        let thumbnails = currentData.thumbnails
        thumbNailsRemove.map((item) => {
            thumbnails = thumbnails.filter((value) => value !== item)
            return thumbnails
        })
        currentData.thumbnails = thumbnails
        useData(currentData)
        setThumbNailsRemove([])
        document.getElementById('selectedFile2').value = ""
    }

    const uploadImage = (file) => {
        const fd = new FormData();
        fd.append('image', file, file.name);
        Axios.post(props.base_url + 'endpoint/upload.php', fd
        ).then(res => {
            console.log(res);
        }
        );
    }

    /* Google Maps */
    const UpdateGoogleMaps = (data) => {
        useData(data)
    }


    const SetGoogleMap = useCallback(
        (map) => {
            let new_data = { ...data }
            new_data.google_map = map
            UpdateGoogleMaps(new_data)
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    )


    /* Calls */
    const updateEstate = (e) => {
        e.preventDefault()
        Axios.post(endpoint, { operation: "update_estate", api_key: props.api_key, estate_id: props.estate_id, formData: data })
            .then(res => {
                props.closeModal()
            })
    }

    const FetchInitialFields = () => {
        Axios.post(endpoint, { operation: "read_category_and_custom_fields", api_key: props.api_key, category_id: data.category_id })
            .then(res => {
                if (res.data.length > 0) {
                    SetInitialCustomFields(res.data[0].fields.custom_fields)
                    SetInitialServices(res.data[0].fields.services)
                }
            })
    }

    /* Effects */
    useEffect(() => {
        FetchInitialFields()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /* Others */
    const customFields = Object.values(Object.values(props.data.custom_fields)[0])
    const services = Object.values(Object.values(props.data.custom_fields)[1])
    const SetInitialCustomFields = (data) => { setInitialCustomFields(data) }
    const SetInitialServices = (data) => { setInitialServices(data) }
    const customDefaultValue = (name) => {
        let value
        customFields.map((item) => {
            if (item.name[0] === name) {
                value = item.value[0]
            }
            return value
        })
        return value
    }
    const serviceDefaultValue = (name) => {
        let value
        services.map((item) => {
            if (item.name[0] === name) {
                value = item.value[0]
            }
            return value
        })
        return value
    }

    return (
        <>
            <div>
                <h5>Imagen Principal</h5>
                {data.image &&
                    <p>{data.image}</p>
                }
                <input type="file" id="selectedFile" style={{ display: 'none' }} onChange={AddMainImage} />
                <input className="mb-3 btn btn-sm btn-secondary" type="button" value="Elegir imagen" onClick={() => document.getElementById('selectedFile').click()} />
                <h5>Imagenes adicionales</h5>
                <div className="mb-3">
                    {data.thumbnails && data.thumbnails.map((item, index) => (
                        <img className={thumbNailsRemove.includes(item) && 'thumbnail-selected'} id={item} key={index} onClick={() => RemoveAdditionalImage(item)} style={{ width: '150px', height: '100px', marginRight: '0.50rem', marginBottom: '0.50rem' }} src={props.base_url + "endpoint/images/estates/" + item} alt="Property Thumbnail" />
                    ))}
                </div>
                <input type="file" id="selectedFile2" style={{ display: 'none' }} onChange={AddAdditionalImage} multiple />
                <input className="mb-3 btn btn-sm btn-secondary" type="button" value="Elegir imagenes" onClick={() => document.getElementById('selectedFile2').click()} />
                {thumbNailsRemove.length > 0 && <button className="btn btn-sm btn-danger" style={{ top: '-8px', marginLeft: '1rem', position: 'relative' }} onClick={RemoveSelected}>Borrar Selecccionadas</button>}
            </div>
            <Form action="#" id="x">
                <Form.Group controlId="title">
                    <div className="row">
                        <div className="col-4"><Form.Label>Leyenda de presentación</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.title} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="transaction">
                    <div className="row">
                        <div className="col-4"><Form.Label>Transacción pretendida</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.transaction} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="asking_price">
                    <div className="row">
                        <div className="col-4"><Form.Label>Asking price</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.asking_price} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="street">
                    <div className="row">
                        <div className="col-4"><Form.Label>Calle y número</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.street} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="street_2">
                    <div className="row">
                        <div className="col-4"><Form.Label>Colonia</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.street_2} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="zone">
                    <div className="row">
                        <div className="col-4"><Form.Label>Municipio/Alcaldía</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.zone} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="state">
                    <div className="row">
                        <div className="col-4"><Form.Label>Estado</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.state} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>

                {initialCustomFields && initialCustomFields.map((item, index) => {
                    let value = customDefaultValue(item.field_name)
                    return (
                        <Form.Group key={index} controlId={item.field_name}>
                            <div className="row">
                                <div className="col-4"><Form.Label>{item.field_description}</Form.Label></div>
                                <div className="col-8"><Form.Control data-attr={item.field_description} defaultValue={value} type="text" onKeyUp={(HandleCustomFields)} /></div>
                            </div>
                        </Form.Group>
                    )
                })}

                <h3 className="mb-3">Servicios</h3>
                <Form.Group controlId="energy">
                    <div className="row">
                        <div className="col-4"><Form.Label>Energia</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.energy} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="water">
                    <div className="row">
                        <div className="col-4"><Form.Label>Agua</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.water} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="communications">
                    <div className="row">
                        <div className="col-4"><Form.Label>Telecomunicaciones</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.communications} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="natural_gas">
                    <div className="row">
                        <div className="col-4"><Form.Label>Gas natural</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.natural_gas} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>

                {initialServices && initialServices.map((item, index) => {
                    let value = serviceDefaultValue(item.field_name)
                    return (
                        <Form.Group key={index} controlId={item.field_name}>
                            <div className="row">
                                <div className="col-4"><Form.Label>{item.field_description}</Form.Label></div>
                                <div className="col-8"><Form.Control data-attr={item.field_description} defaultValue={value} type="text" onKeyUp={(HandleServicesFields)} /></div>

                            </div>
                        </Form.Group>
                    )
                })}

                <h3 className="mb-3">Vecindario</h3>
                <Form.Group controlId="neighbours">
                    <div className="row">
                        <div className="col-4"><Form.Label>Vecinos adyacentes y cercanos</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.neighbours} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="surroundings">
                    <div className="row">
                        <div className="col-4"><Form.Label>Descripción del entorno</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.surroundings} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <Form.Group controlId="indications">
                    <div className="row">
                        <div className="col-4"><Form.Label>Como llegar?</Form.Label></div>
                        <div className="col-8"><Form.Control defaultValue={props.data.indications} type="text" onKeyUp={HandleCommonFields} /></div>
                    </div>
                </Form.Group>
                <div style={{ height: '500px' }}>
                    <GoogleMap googleMap={props.data.google_map} editable={true} draggable={true} SetGoogleMap={SetGoogleMap} />
                </div>

                <div className="mt-3 text-center"><button onClick={updateEstate} className="btn btn-primary">Guardar</button></div>

            </Form>
        </>
    )
}
export default EstateUpdate